import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "17", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h12",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M15 9.34V6h1a2 2 0 0 0 0-4H7.89", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PinOff";
const PinOff = memo(themed(Icon));
export {
  PinOff
};
//# sourceMappingURL=pin-off.js.map
